import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { LocalStorageService } from '../../../../app/core/utils/local-stoarge-service';
import { ModalLoaderService } from '../../../../app/core/utils/modal-loader-service';
import { HeaderComponent } from './includes/header/header.component';
import { FooterComponent } from './includes/footer/footer.component';
import { MenuComponent } from './includes/menu/menu.component';
import { LayoutStateService } from '../../../../app/core/services/layout-state.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    MenuComponent,
    RouterOutlet
  ]
})
export class LayoutComponent implements OnInit {

  constructor(
    public state: LayoutStateService,
    private mls: ModalLoaderService,
    private cdRef: ChangeDetectorRef,
    private lsService: LocalStorageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.mls.getLink().subscribe((res: any) => {});
    this.cdRef.detectChanges();

    const returnUrl = this.lsService.get('returnUrl');
    if (returnUrl != undefined && returnUrl != null) {
      this.lsService.remove('returnUrl');
      this.router.navigate([returnUrl]);
    }
  }
}
